<div class="detail">
  <h1>Uživatelské exporty</h1>

  <div class="mt-20">Tabelární výpisy měřených úseků a klasifikace stavu dle TP 87</div>
  <div class="mt-20">
    <!--<a href="https://cloud.gmtech.cz/s/n49a2fMGajW68PN/download/Useky_dle_TP87.zip" target="_blank" class="button">Stáhnout</a>-->
    <gmt-button [clickAction]="onCreateExport" class="w-200">
      <ng-container *ngIf="!exportLoading">Generovat</ng-container>
      <ng-container *ngIf="exportLoading">Probíhá generování</ng-container>
    </gmt-button>
  </div>
  <div class="mt-20">Vizuální diagnostika ve formátu SHP</div>
  <div class="mt-20">
    <!--<a href="https://cloud.gmtech.cz/s/4a56syKK3BjJnST/download/ExportSHP.zip" target="_blank" class="button">Stáhnout</a>-->
    <gmt-button [clickAction]="onCreateExportShp" class="w-200">
      <ng-container *ngIf="!exportShpLoading">Generovat</ng-container>
      <ng-container *ngIf="exportShpLoading">Probíhá generování</ng-container>
    </gmt-button>
  </div>

  <help [helpId]="helpIds.VM_PANEL_EXPORTS" class="cm-help-page"></help>
</div>
